/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import { HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';
import { Dialog, DialogFooter, Icon, Link, Label } from 'office-ui-fabric-react';
import { AppButton } from '../AppButton';
import { LEARN_MORE_URL } from '../../../AppConstants';
import { getDiamondIconStyles, getTopLabelStyles, getModalProps, getDialogContentProps, getDialogStyles } from '../../common/styles/Popup.styles';
import { AppLayoutSettings } from '../../common/styles/common.styles';

interface LicensePopupState {
    isLicensedUser: boolean
}

export class LicensePopup extends React.PureComponent<{}, LicensePopupState> {
  constructor(props: {}) {
    super(props);

    this.state = {
        isLicensedUser: HostAppSettings.IsSettingTrue(HostAppSettingName.IsLicensedUser),
    };
  }

  private LicenseStateChangedEventListener(args: OfficeCore.LicenseFeatureStateChangedEventArgs) {
      HostAppSettings.Set(HostAppSettingName.IsLicensedUser, args.isEnabled);
      this.setState({ isLicensedUser: args.isEnabled });
  }

  public componentDidMount() {
    if (!this.state.isLicensedUser) {
        Office.license.onFeatureStateChanged('WordTranscribeConsumer', async (args: OfficeCore.LicenseFeatureStateChangedEventArgs) => this.LicenseStateChangedEventListener(args));
    }
  }

  public render() {
      if (this.state.isLicensedUser) {
          return null;
      } else {
        const title: string | JSX.Element =
            <div>
                <div>
                    <Icon aria-hidden={true} iconName="Diamond" styles={getDiamondIconStyles()} />
                </div>
                <Label styles={getTopLabelStyles()}>
                    {TranscriptionStrings.LicensePopupTitleLabel}
                </Label>
            </div>

        return (
            <Dialog
                dialogContentProps={getDialogContentProps(title)}
                modalProps={getModalProps()}
                hidden={this.state.isLicensedUser}
                styles={getDialogStyles()}
            >
                <Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{TranscriptionStrings.LicensePopupBodyLabel}</Label>
                <Link styles={AppLayoutSettings.AppCommonStyles.getLearnMoreLinkStyles()} href={LEARN_MORE_URL} target="_blank">{TranscriptionStrings.TranscriptionPaneLearnLabel}</Link>
                <DialogFooter>
                    <AppButton
                        type={'AppButtonProps'}
                        id="GoPremiumButton"
                        text={TranscriptionStrings.LicensePopupGoPremiumLabel}
                        onExecute={async () => { await Office.license.launchUpsellExperience('transcription'); }}
                    />
                </DialogFooter>
            </Dialog>
         );
      }
  }
}